<script setup lang="ts">
import { Ref, computed, onMounted, ref } from 'vue';
import { deviceWidths } from '../../constants';
import useContext from '@/composables/useContext';
const { page, toLitiumMediaUrl } = useContext();

const hasBlocks = computed(() => {
  return page.value?.blocks && Object.keys(page.value.blocks).length !== 0;
});

let isMobile: Ref<null | boolean> = ref(null);

const imageUrl = computed(() => {
  if (isMobile?.value == null) {
    return '';
  }

  if (isMobile?.value) {
    const mobileImage = page.value?.fields?.MobileImage;
    if (mobileImage?.id) {
      return toLitiumMediaUrl(mobileImage.id, {
        maxWidth: deviceWidths.phoneMaxWidth
      });
    }
  }

  if (
    !page.value?.fields?.Image?.id &&
    !page.value?.dataJson?.dataJson?.category?.imageId
  ) {
    return '';
  }

  return toLitiumMediaUrl(
    page.value.fields?.Image?.id || page.value?.dataJson?.dataJson?.category?.imageId,
    {
      maxWidth: 1440
    }
  );
});

onMounted(() => {
  isMobile.value =
    typeof window !== 'undefined' &&
    window.innerWidth < deviceWidths.phoneMaxWidth;
  window.addEventListener('resize', () => {
    if (typeof window !== 'undefined') {
      const isMobileScreenSize = window.innerWidth < deviceWidths.phoneMaxWidth;
      if (isMobileScreenSize !== isMobile?.value) {
        isMobile.value = isMobileScreenSize;
      }
    }
  });
});

const imageAlt = computed(() => {
  return page.value?.fields?.Image?.filename || '';
});

const isMobileImage = computed(
  () => isMobile?.value && page.value?.fields?.MobileImage?.id
);
</script>

<template>
  <div class="category-media" v-if="imageUrl && !hasBlocks">
    <img
      :src="imageUrl"
      :alt="imageAlt"
      :class="{ 'category-media__mobile-image': isMobileImage }"
      class="category-media__image"
    />
  </div>
</template>

<style>
.category-media {
  margin: 0 auto;
  max-width: var(--site-max-width);
  position: relative;
}

.category-media__image {
  width: 100%;
  height: 300px;
  object-fit: cover;
}

@media (--desktop) {
  .category-media__image {
    height: auto;
    object-fit: contain;
    padding: 0;
  }
}

.category-media__mobile-image {
  max-height: 90vh;
  height: auto;
}
</style>
